import React from 'react'
import './styles/apropos.css'
import { FaCheck } from 'react-icons/fa'

const Apropos = () => {
  return (
    <div className='whyisimm_container'style={{marginLeft:'-5px'}}>
      
      <div className='whyisimm_img'>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d395.2542935246911!2d9.568007610072064!3d36.093129464635915!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12fc5d0078c3dd4b%3A0x47882369d3e5bf20!2sAssociation%20El%20Wifak-Bargou!5e1!3m2!1sfr!2stn!4v1722945919324!5m2!1sfr!2stn"
 width="100%"
          height="300"
          style={{ border: "0", borderRadius: '10%' }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
 


      </div>
       <div className='whyisimm_description'>
         <div>
          <h2>À  propos de nous :</h2>
          <p>L’ONG EL WIFAK Bargou est une association de
développement qui est fondée en 1998, elle est spécialisée
dans le développement économique local, l’environnement
et la micro-finance.
<br/>
Les principales activités de l’association sont articulées
autour de l’appui aux jeunes micro-entrepreneurs, la
formation et l'accompagnement des organisations
professionnelles de base.</p>
            <h2>Nos services :</h2>
            <p>L'association El Wifak offre des prêts dans les secteurs suivants :
            </p> 
            <div style={{display:'grid', gridTemplateColumns:'repeat(2,auto)',gap:'20px'}}>
                <span>
                    <FaCheck className='span_description'/> Agriculture
                    </span>
                <span>
                    <FaCheck className='span_description'/> Industrie
                </span>
                <span>
                    <FaCheck className='span_description'/>  Commerce
                </span>
                <span>
                    <FaCheck className='span_description'/> Services
                </span>
                <span>
                    <FaCheck className='span_description'/> Artisanat
                </span>
                <span>
                    <FaCheck className='span_description'/> Grandes cultures
                </span>  
                <span>
                    <FaCheck className='span_description'/> Cultures maraîchères
                </span>        
                <span>
                    <FaCheck className='span_description'/> Amélioration des conditions de vie
                </span>       
            </div>
            <br/>
            <h2>Notre objectif général :</h2>
         <p>Promouvoir le développement local et régional, la
création de l’emploi, l’entrepreneuriat et contribuer à
l’amélioration de la situation socio-économique des
populations rurales.</p> 
         </div>
       </div>
    </div>
  )
}

export default Apropos